import { render, staticRenderFns } from "./resumo-mensal.vue?vue&type=template&id=a2452120&scoped=true&"
import script from "./resumo-mensal.vue?vue&type=script&lang=js&"
export * from "./resumo-mensal.vue?vue&type=script&lang=js&"
import style0 from "./resumo-mensal.vue?vue&type=style&index=0&id=a2452120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2452120",
  null
  
)

export default component.exports